import { baseClassName } from "../constants";
import { joinClassName } from "../utils/cssUtils";
import { makeGridLayout } from "../utils/gridLayoutUtils";
import {
    oneCol,
    fullWidth,
    verticalCol,
} from "../components/ContentWrapper/contentLayouts/FLP_contentLayouts";
import classNames from "classnames";

export const defaultGrid = makeGridLayout({
    gridClasses: joinClassName(baseClassName, "defaultGrid"),
    defaultContent: oneCol,
});

export const featuredGrid = makeGridLayout({
    gridClasses: classNames(
        joinClassName(baseClassName, "defaultGrid"),
        joinClassName(baseClassName, "maxChildren-7")
    ),
    defaultContent: oneCol,
    positionalContent: [fullWidth],
});

export const featuredGrid_noLimit = makeGridLayout({
    gridClasses: classNames(joinClassName(baseClassName, "defaultGrid")),
    defaultContent: oneCol,
    positionalContent: [fullWidth],
});

export const defaultSideScroll = makeGridLayout({
    gridClasses: classNames(
        joinClassName(baseClassName, "sideScroll"),
        joinClassName(baseClassName, "defaultGrid")
    ),
    defaultContent: oneCol,
});

export const featuredVerticalRightCol_noLimit = makeGridLayout({
    gridClasses: classNames(
        joinClassName(baseClassName, "defaultGrid"),
        joinClassName(baseClassName, "featuredWithVertical")
    ),
    defaultContent: oneCol,
    positionalContent: [verticalCol],
});

export const featuredDesc_noLimit = makeGridLayout({
    gridClasses: classNames(joinClassName(baseClassName, "defaultGrid")),
    defaultContent: oneCol,
    positionalContent: [fullWidth, oneCol, oneCol, oneCol],
});
